import { render, staticRenderFns } from "./OxygenHtmlAttributes.vue?vue&type=template&id=1fb53768&"
import script from "./OxygenHtmlAttributes.vue?vue&type=script&lang=ts&"
export * from "./OxygenHtmlAttributes.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenHtmlAttributes.vue?vue&type=style&index=0&id=1fb53768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports